<template>
  <div class="footer">
    <img src="../assets/company1.png" />
    <div class="company">
      <div class="company_msg">
        <span><div class="title">公司地址:</div> 天津市津南区津沽大街295号</span>
        <span><div class="title">联系人:</div> {{ company[0].name }}</span>
        <span><div class="title">联系电话:</div> {{ company[0].phone }}</span>
        <span><div class="title">电子邮箱:</div> {{ company[0].email }}</span>
      </div>
      <div class="weixin">
        <img src="../assets/weixinCode.png" />
      </div>
    </div>

    <div class="copyRight">
      <span>Copyright©天科云创科技有限公司All right reserved</span>
      &nbsp; &nbsp; &nbsp;
      <span><a href="https://beian.miit.gov.cn">津ICP备2022005810号-2</a></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterView",
  data() {
    return {
      company: [],
    };
  },
  methods: {
    getCompany() {
      this.$axios.get("/company").then((res) => {
        this.company = res.data.data;
      });
    },
  },
  created() {
    this.getCompany();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  bottom: 0;
  background: rgb(37,115,191);
  background-size: 100% 100%;
  color: white;
  font-size: 1.3rem;
  line-height: 2;
  img {
    width: 30%;
    object-fit: contain;
    margin-left: 50px;
    margin-top: 10px;
    @media screen and (max-width: 768px) {
      margin: 0 auto;
      width: 100%;
    }
  }
  .company {
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    .company_msg {
      margin-left: 100px;
      display: flex;
      flex-direction: column;
      @media screen and (max-width: 768px) {
        margin: 0 auto;
      }
      .title{
        width: 100px;
        text-align: justify;
        text-align-last: justify;
        display: block;
        float: left;
        position: relative;
        margin-right: 10px;
        height: 30px;
      }
      .title::after{
        content: '';
        width: 100%;
        display: inline-block;

      }
      img {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        object-fit: contain;
        vertical-align: middle;
      }
    }
    .weixin {
      img {
        width: 200px;
        height: 200px;
        margin-right: 100px;
        @media screen and (max-width: 768px) {
          margin: 5px;
        }
      }
    }
  }
}
.copyRight {
  position: relative;
  text-align: center;
  color: white;
  font-weight: bolder;
  font-size: 1.3rem;
  bottom: 0;
  span {
    @media screen and (max-width: 768px) {
      font-size: 1rem;
      flex-direction: column;
      text-align: center;
    }
  }
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  a:-webkit-any-link {
    color: white;
    text-decoration: none;
  }
}
</style>